import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const additionalInformationSlice = createSlice({
  name: "pendingAdditionInformation",
  initialState: false,
  reducers: {
    setFieldCompleted: (state, action: PayloadAction<boolean>) => {
     return action.payload
    },
  },
});

export const { setFieldCompleted } = additionalInformationSlice.actions;
export default additionalInformationSlice.reducer;
